import { MDBBtn, MDBCol, MDBInput, MDBRow } from 'mdb-react-ui-kit';
import { Component } from 'react';
import { connect } from 'react-redux';
import SpinnerWaitComponent from '../../SpinnerWaitComponent';
import Attributes from '../../../apis/Attributes';
import AccessCode from '../../../apis/AccessCode';

class AccessCodesComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSpinnerWaitShown: false,
            form_controls: {
                accesscode: { value: '', is_invalid: false, message: '', instruction: '' }
            },
            accesscodes: []
        };

        this.formItemOnChangeHandler = this.formItemOnChangeHandler.bind(this);
        this.formResetButtonClickHandler = this.formResetButtonClickHandler.bind(this);
        this.formQueryButtonClickHandler = this.formQueryButtonClickHandler.bind(this);
        this.queryAccessCode = this.queryAccessCode.bind(this);
    }

    componentDidMount() {
        
    }


    formQueryButtonClickHandler() {
        this.queryAccessCode();
    }

    async queryAccessCode() {
        this.setState({ isSpinnerWaitShown: true });
        try {
            let form_items = {
                accesscode: this.state.form_controls['accesscode'].value
            };

            let response = await AccessCode.queryAccessCode(form_items);

            //console.log(response.data);

            this.setState({ accesscodes: response.data });
            this.setState({ isSpinnerWaitShown: false });
        } catch (error) {
            this.setState({ isSpinnerWaitShown: false });
            if (error.response.data.message !== undefined) {
                this.props.showToastNotification('error', 'Erişim Kodu Sorgulanamadı. ' + error.response.data.message);
            } else {
                this.props.showToastNotification('error', 'Erişim Kodu Sorgulanamadı. Bilinmeyen hata!');
            }
        }
  
    }

    formItemOnChangeHandler(event) {
        let key = event.target.id;
        let value = event.target.value;
        let oldValue = event.target.defaultValue;

        // Negated regex: matches ANY character that is NOT a digit or an English letter
        const invalidCharsRegex = /[^0-9A-Za-z]/g;

        // Remove invalid characters by replacing them with an empty string
        let cleanValue = value.replace(invalidCharsRegex, '');

        let formControlCopy = { ...this.state.form_controls[key] }; // copy content instead of reference
        
        // Convert the cleaned value to uppercase using English locale rules
        formControlCopy.value = cleanValue.toLocaleUpperCase('en-US'); 
        
        let formControlsCopy = { ...this.state.form_controls };
        formControlsCopy[key] = formControlCopy;

        this.setState({ form_controls: formControlsCopy }); // reference is changed, now all visible parts will be refreshed
    }

    formResetButtonClickHandler() {
        let form_controls = {};  
        form_controls['accesscode'] = {value: '', is_invalid: false, message: '', instruction: ''};
        this.setState({ form_controls: form_controls });
    }

    render() {

        let accesscode = this.state.accesscode;
        let spinnerWaitComponent = '';
        if (this.state.isSpinnerWaitShown) {
            spinnerWaitComponent = (<SpinnerWaitComponent />);
        }


        let disabled = true;
        if (this.state.form_controls['accesscode'].value.length >= 3) {
                disabled = false;
        }

        return (
            <>
                <h3>Erişim Kodları</h3>
                <p>Erişim kodlarının kullanım durumu buradan kontrol edilir.</p>
                <br />

                <MDBRow>
                    <MDBCol className='mb-4'>
                        <MDBInput
                            id='accesscode'
                            label='Erişim Kodu'
                            onChange={this.formItemOnChangeHandler}
                            value={this.state.form_controls['accesscode'].value}
                            aria-describedby='accesscode_info'
                        />
                        <div id='accesscode_info' className='form-text'>
                            <small className='fw-light'>Sorgulanacak erişim kodunun girilmesi zorunludur.</small>
                        </div>
                    </MDBCol>
                </MDBRow>

                {this.state.accesscodes.map((item, index) => (
                    <MDBRow key={index}>
                        <MDBCol className='mb-4'>
                            {item.code} - {item.teacher !== null ? 'LMS\'te hesap var: ' + item.teacher.name + ' ' + item.teacher.surname + ' - ' + item.teacher.email + ' - ' + item.teacher.mobile_phone 
                                    : item.email !== null ? 'LMS\'te hesap yok, ancak kod bir epostaya ait: ' + item.name + ' ' + item.surname + ' - ' + item.email + ' - ' + item.phone : 'Erişim kodu hiç kullanılmamış, virgin durumda.'} 
                        </MDBCol>
                    </MDBRow>
                ))}
         

                {this.state.accesscodes.length === 0 && (
                    <MDBRow>
                        <MDBCol className='mb-4'>
                            Kayıt yok.
                        </MDBCol>
                    </MDBRow>
                )}

                <MDBBtn color='primary' className='me-3' disabled={disabled} onClick={this.formQueryButtonClickHandler}>SORGULA</MDBBtn>
                <MDBBtn color='secondary' disabled={disabled} onClick={this.formResetButtonClickHandler}>SİL BAŞTAN</MDBBtn>

                {spinnerWaitComponent}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        authenticatedUser: state.authenticatedUser,
        mainPageTitle: state.mainPageTitle,
        showToastNotification: state.showToastNotificationCallback
    }
};

export default connect(mapStateToProps)(AccessCodesComponent);